import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=7f287b17"
import script from "./textarea.vue?vue&type=script&lang=ts"
export * from "./textarea.vue?vue&type=script&lang=ts"
import style0 from "./textarea.vue?vue&type=style&index=0&id=7f287b17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports